import { useEffect, useState } from "react"
import { sort } from 'fast-sort'
import { useDispatch, useSelector } from "react-redux"
import { useScope } from "../SelectProjectCompanyContainer"
import { useUsers } from "../../core/utils/hooks/useUsers"
import { useFilter } from "../../core/utils/hooks/useFilter"
import { AssistanceScreen } from "../../screen/AssistanceScreen"
import { SubheaderFilter } from "../../components/Subheader"
import { setData } from "../../core/redux/app/Actions"
import Send from "../../core/communication"

const AssistanceContainer = () => {
  const dispatch = useDispatch();
  const { referenceAssistance, dataReferenceTotal, dataTotal, assistance, allData } = useSelector(state => state.app.assistanceData || {
    referenceAssistance: [], dataReferenceTotal: [], dataTotal: [], assistance: [], allData: []
  });
  const contentData = useSelector((state) => state.app.contents);
  const { scope, scopeType, projectsByScope } = useScope();
  const { users } = useUsers();
  const [loading, setLoading] = useState(false);
  const [valuesToSearch, onChange, reload, onReload] = useFilter('period-filter');

  useEffect(() => {
    const newProjects = valuesToSearch?.projects && valuesToSearch.projects.filter(row => row?.value);
    if(!Array.isArray(newProjects) || !newProjects.length) {
      const formattedProjects = projectsByScope.map(row => ({ value: row?.id, label: row?.description }));
      onChange('projects', formattedProjects);
    }

    loadData(valuesToSearch?.projects || []);
  }, [reload]);

  const goTo = (to) => {
    if (to === "/details/assistance") {
      onChange("type", valuesToSearch.type !== "Atendimento" ? "Atendimento" : "")
    } else if ("/details/content") {
      onChange("type", valuesToSearch.type !== "Conteúdo" ? "Conteúdo" : "")
    }

    onReload()
  }

  const loadData = async (projects) => {
    setLoading(true)

    let extraQuery = ""
    let newProjects = projects.filter(row => row || row?.value) || []
    let type = 'project';

    if (!Array.isArray(newProjects) || !newProjects.length) {
      newProjects = [{ value: scope?.id }];
      type = scopeType;
    }

    const groupedProjects = ['Ambev', 'SEMPROR', 'Vale', 'CUIA'];

    newProjects = newProjects
      .filter((item) => item?.value)
      .map((project) => (!groupedProjects.includes(project.label) ? `${project?.value}'` : project?.value))
      .toString()

    if(!newProjects) return;

    if (valuesToSearch?.year) {
      const start = `${valuesToSearch?.year}`.split("|")[0]
      const end = `${valuesToSearch?.year}`.split("|")[1]
      extraQuery += `&start=${start}&end=${end}`
    }

    if (valuesToSearch?.yearReference) {
      const start = `${valuesToSearch?.yearReference}`.split("|")[0]
      const end = `${valuesToSearch?.yearReference}`.split("|")[1]
      extraQuery += `&startReference=${start}&endReference=${end}`
    }

    if (valuesToSearch?.type) {
      extraQuery += `&type=${valuesToSearch?.type}`
    }

    const contents = Send.get("/dw/content", `projects=${newProjects}${extraQuery}&scopeType=${type}`)
    // extraQuery += "&forms='77823afb-d96f-43d5-b895-bf32ad055899'"
    
    const assistance = Send.get(`/dw/assistance/data`, `projects=${newProjects}${extraQuery}&scopeType=${type}`)

    // const evidence = Send.get(`/dw/data/`, `projects='${scope?.id}'${extraQuery}`);

    await Promise.all([contents, assistance]).then(([contents, { data, reference, dataTotal, dataReferenceTotal, allData }]) => {
      dispatch(setData({
        assistanceData: {
          dataTotal, dataReferenceTotal,
          assistance: data || [],
          referenceAssistance: reference || [],
          allData
        },
        contents: contents || [],
        evidence: []
      }))
    })

    setLoading(false)
  }

  const calculateTotalCount = (data, type) => {
    return Array.isArray(data) ?
      data.filter(item => item.Tipo === type)
          .reduce((total, { notas }) => total + notas, 0) :
      0;
  };

  const calculateVariation = (ref, value) => {
    return ref === 0 ? value > 0 ? 100 : 0 : parseFloat((value / ref) * 100 - 100).toFixed(0)
  }
  
  const countTotalAssistance = calculateTotalCount(dataTotal, 'Atendimento');
  const countTotalContent = calculateTotalCount(dataTotal, 'Conteúdo');
  const countTotalReferenceAssistance = calculateTotalCount(dataReferenceTotal, 'Atendimento');
  const countTotalReferenceContent = calculateTotalCount(dataReferenceTotal, 'Conteúdo');

  const formatMediaByStep = (data) => {
    return data?.map(item => ({
      option: item.Etapa,
      value: item.media_nota,
    })) || [];
  };
  
  const formatAcceptMediaByStep = {
    fields: Array.isArray(assistance) ? formatMediaByStep(assistance) : [],
    references: Array.isArray(assistance) ? formatMediaByStep(referenceAssistance) : []
  };
  
  const calculateRadarValues = (assistance, referenceAssistance) => {
    const uniqueSteps = [...new Set([...(assistance || []), ...(referenceAssistance || [])].map(item => item?.Etapa))];
  
    return uniqueSteps.map(Etapa => ({
      name: Etapa,
      value: parseFloat(assistance.find(a => a.Etapa === Etapa)?.media_nota || 0).toFixed(2),
      reference: parseFloat(referenceAssistance.find(a => a.Etapa === Etapa)?.media_nota || 0).toFixed(2)
    }));
  };
  
  const formatRadar = sort(calculateRadarValues(assistance, referenceAssistance)).asc([
    u => u.value,
    u => u.reference
  ]);

  const formatStep = (step, assistance, referenceAssistance) => {
    const assistanceItem = assistance.find(a => a.Etapa === step) || {};
    const referenceItem = referenceAssistance.find(a => a.Etapa === step) || {};
  
    return {
      name: step,
      //nota 0
      "Período atual: Nº de atendimentos sem interação": assistanceItem.nota_0 || 0,
      "Período anterior: Nº de atendimentos sem interação": referenceItem.nota_0 || 0,

      //nota 2
      "Período atual: Nº de atendimentos com Interação": assistanceItem.nota_2 || 0,
      "Período anterior: Nº de atendimentos com Interação": referenceItem.nota_2 || 0,

      //nota 3
      "Período atual: Nº de recomendações aplicadas de forma parcial": assistanceItem.nota_3 || 0,
      "Período anterior: Nº de recomendações aplicadas de forma parcial": referenceItem.nota_3 || 0,

      //nota 5
      "Período atual: Nº de recomendações aplicadas de forma total": assistanceItem.nota_5 || 0,
      "Período anterior: Nº de recomendações aplicadas de forma total": referenceItem.nota_5 || 0,
  
      //variação nota 0
      'Var: Sem interação': calculateVariation(referenceItem.nota_0 || 0, assistanceItem.nota_0 || 0),

      //variação nota 2
      'Var: Interação': calculateVariation(referenceItem.nota_2 || 0, assistanceItem.nota_2 || 0),

      //variação nota 5
      'Var: Aplicação Total': calculateVariation(referenceItem.nota_5 || 0, assistanceItem.nota_5 || 0),

      //variação nota 3
      'Var: Aplicação Parcial': calculateVariation(referenceItem.nota_3 || 0, assistanceItem.nota_3 || 0),
      
      nota_1: assistanceItem.nota_1 || 0,
      nota_4: assistanceItem.nota_4 || 0,
      reference_nota_1: referenceItem.nota_1 || 0,
      reference_nota_4: referenceItem.nota_4 || 0
    };
  };

  const uniqueSteps = [...new Set([...(assistance || []), ...(referenceAssistance || [])].map(item => item?.Etapa))];
  
  const formattedBarChartData = uniqueSteps.map(step => formatStep(step, assistance, referenceAssistance));
  
  const sortedBarChartData = sort(formattedBarChartData).asc([
    u => u.value,
    u => u.reference
  ]);

  return (
    <>
      <SubheaderFilter
        {...{
          setLoading,
          loading,
          dateType: 1,
          periodReference: true,
          keyFilter: 'period-filter'
        }}
      />
      <AssistanceScreen
        {...{
          users,
          contentData,
          goTo,
          formatRadar,
          formatAcceptMediaByStep,
          formatBarChartAssistance: sortedBarChartData,
          countTotalAssistance,
          countTotalReferenceAssistance,
          countTotalContent,
          countTotalReferenceContent,
          allData,
          projectId: scope?.id
        }}
      />
    </>
  )
}

export default AssistanceContainer